import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data.map(item => ({
      ...item,
      new_tasks_count: item.stages?.[0]?.tasks_aggregate?.aggregate?.count || 0,
    }))
  }, [data])
}
